export default __webpack_public_path__ + "static/media/OlegPrutz.f436afee.png";